<app-sticky-bar />
<div class="shell">
  <div class="shell__inner shell__header">
    <app-profile-header />
    <app-nav-bar />
  </div>
  <div class="shell__inner shell__content">
    <router-outlet />
  </div>
  <div class="shell__inner">
    <app-page-footer />
  </div>
</div>
